import { NgModule } from '@angular/core';
import { SelectWithSearchModule } from '@core/components/select-with-search/select-with-search.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaintenanceTypeComponent } from './maintenance-type.component';
import { MaintenanceTypeService } from './maintenance-type.service';

@NgModule({
  entryComponents: [
    MaintenanceTypeComponent
  ],
  declarations: [
    MaintenanceTypeComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    SelectWithSearchModule,
  ],
  providers: [
    MaintenanceTypeService
  ],
  exports: [
    MaintenanceTypeComponent
  ]
})
export class MaintenanceTypeModule { }
